import { useMemo } from 'react';

import { useIsDeleteUserEnabled } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useRemoveUserSectionSettings: UseMainUIFeatureSettings<'removeUserSection'> = (options) => {
  const removeUserSectionOverrides = options?.overrides?.removeUserSection;

  const viewerCanRemoveUser = useIsDeleteUserEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: viewerCanRemoveUser,
      ...removeUserSectionOverrides,
    }),
    [removeUserSectionOverrides, viewerCanRemoveUser]
  );
};
